import { useMemo, useCallback } from 'react';

export const useCloseWindow = () => {
  const isAbleToCloseWindow = useMemo(() => {
    return window.opener !== null || window.history.length === 1;
  }, []);

  const closeWindow = useCallback(() => {
    window.close();
  }, []);

  return { isAbleToCloseWindow, closeWindow };
};
